/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const ssoCallbackInputDataSchema = z.object({
	code: z.string(),
	invitationToken: z.string().nullable().optional(),
})

export type SsoCallbackInputDataSchema = z.infer<typeof ssoCallbackInputDataSchema>
